import useTranslation from '@/hooks/i18n';
import classNames from 'classnames';

type TagType = 'MISSION' | 'CHAPTER' | 'PROGRAMME' | 'ARTICLE' | 'PODCAST' | 'COURSE';

const borderColor = {
  MISSION: 'border-[#E57852]',
  CHAPTER: 'border-[#72C9BF]',
  PROGRAMME: 'border-[#F090A6]',
  ARTICLE: 'border-[#9FC3FA]',
  PODCAST: 'border-[#B1FCD0]',
  COURSE: 'border-[#E8B3F3]',
};

export default function DefaultContentTemplateTags({
  tags = [],
  className,
  duration,
  type,
  isDefaultContentTemplate = false,
  uppercase = false,
}: {
  tags?: string[];
  className?: string;
  duration?: string;
  type?: TagType;
  uppercase?: boolean;
  isDefaultContentTemplate?: boolean;
}) {
  const { t } = useTranslation();

  if (tags?.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames('flex flex-wrap gap-4', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      {tags
        ?.filter((t) => t !== '')
        .map((tag) => {
          return (
            <div
              key={tag}
              className={`flex items-center justify-center rounded-2xl border  bg-white px-[10px] py-[5px] text-black ${type ? borderColor[type] : 'border-[#EEEEEE]'}`}>
              <span className={classNames('my-0 text-sh-14-16', { uppercase: uppercase })}>{t(tag)}</span>
              {duration && (
                <>
                  <img src="/icons/clock.svg" className="mx-1 inline-block h-4 w-4" alt="Clock" />{' '}
                  <span className="text-sh-14-16">{duration}</span>
                </>
              )}
            </div>
          );
        })}
    </div>
  );
}
